import { useEffect, useRef, useState } from 'react'
import classes from './MessageLine.module.css'
import { postMessage } from '../../../../store/chatAi-actions'
import { useDispatch, useSelector } from 'react-redux'
import { ReactComponent as ArrowSvg } from '../../../../assests/chat/bina-send-message-arrow.svg';

function MessageLine() {
    
    const [value, setValue] = useState("")
    const disptach = useDispatch()
    const { texts } = useSelector(state => state.translate);
    const chatState = useSelector(state => state.chat)
    const endOfLineRef = useRef()

    useEffect(() => {
        if (endOfLineRef && endOfLineRef.current) {
            endOfLineRef.current.scrollIntoView({ behavior: "smooth" });
        }
    },[value])
    const sendMessage = () => {
        if (value === "") return
        const alerts = {
            internalAlert: texts.chatAlert,
            geminiAlert: texts.geminiAlertText,
            outOfResourceAlert: texts.binaOutOfResourcesText
        }
        disptach(postMessage(value, alerts))
        setValue("")
    }

    const onChange = (e) => {
        setValue(e.target.value)
    }

    const onKeyDown = event => {
        if (event.key === "Enter") {
            event.preventDefault();
            sendMessage()
        }
    }

    let buttonClass = "ArrowContainer"
    if (value === "") {
        buttonClass = "DisabledArrowContainer"
    }
    return (
        <div className={classes.MessageLine}>
            <label for="binaInput"/>
            <input 
                type="text"
                id="binaInput"
                className={classes.TextInput}
                onChange={onChange} 
                value={value} 
                placeholder={texts.typeHere}
                onKeyDown={onKeyDown}
                ref={endOfLineRef}
            >                 
            </input>
            <button alt="שליחה" className={classes[buttonClass]}>
                <ArrowSvg disabled={chatState.id == null} className={classes.Arrow} onClick={sendMessage}/>
            </button>
        </div>
    );
}

export default MessageLine;
